import { render } from "./SwdPdfViewer.vue?vue&type=template&id=9bd473c6&scoped=true"
import script from "./SwdPdfViewer.vue?vue&type=script&lang=js"
export * from "./SwdPdfViewer.vue?vue&type=script&lang=js"

import "./SwdPdfViewer.vue?vue&type=style&index=0&id=9bd473c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd473c6"]])

export default __exports__